import React from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import type { WorkflowInvoiceIssue } from '../workflowInvoiceValidation';
import { useInvoiceIssuesVisible } from './invoiceIssueVisibility';

/** One visible error owner for both ordinary inputs and compound quantities. */
export default function InvoiceField({ field, fields, issues, children }: {
  field?: string; fields?: string[]; issues: WorkflowInvoiceIssue[]; children: React.ReactNode;
}) {
  const { t } = useTranslation('invoices');
  const visible = useInvoiceIssuesVisible();
  const errors = visible ? issues.filter(issue => (fields ?? [field]).includes(issue.field)) : [];
  return <Form.Item noStyle validateStatus={errors.length ? 'error' : undefined}><div className={`invoice-review-field${errors.length ? ' invoice-review-field--invalid' : ''}`}>
    {children}
    {errors.map(error => <div className="invoice-field-error" role="alert" key={error.field}>{t(error.key)}</div>)}
  </div></Form.Item>;
}
